import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import './Register.css'

function Register() {

    const[name,setName]=useState("");
    const[email,setEmail]=useState("");
    const[password,setPassword]=useState("");
    const user={name,email,password}
    const navigate=useNavigate();
    


    const handleChange=(e)=>{
      e.preventDefault();
      console.log(user);

      fetch("https://food-delivery-sid-api.herokuapp.com/api/register",{
        method:"POST",
        body:JSON.stringify(user),
        mode:'cors',
        headers:{
          'Content-type':'application/json'
        }
      })
      .then((data)=>{
        console.log(data)
        navigate('/login')
        alert("Succesfully register")
        
      })
      .catch((err)=>{
        console.log(err)
        alert("Data might wrong")
      })
    }

  return (
    <div className='con111'>
        <div >
            
      <form className='container1'>
      <h3>Register</h3>
      <label>Name</label>
      <input type="name" placeholder='name' className='res-input' onChange={(e)=>{
        setName(e.target.value);
      }}/>
        <label>Email or UserId</label>
        <input type="email" placeholder="userName" className='res-input' onChange={(e)=>{
        setEmail(e.target.value);
      }} />
        <label>Password</label>
        <input type="password" placeholder="password" className='res-input' onChange={(e)=>{
        setPassword(e.target.value);
      }}/>
      <button onClick={handleChange} className='res-btn'>Sing-Up</button>
       
        
      </form>
      </div>
    </div>
  )
}

export default Register
